import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Dropdown, Nav } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";

const titulos = [
  { path: "/", titulo: "Inicio" },
  { path: "/mensajes-virgen/es", titulo: "" },
  { path: "/mensajes-virgen/fr", titulo: "" },
  { path: "/mensajes-virgen/en", titulo: "" },
  { path: "/mensajes-virgen/ger", titulo: "" },
  { path: "/mensajes-jesus", titulo: "Mensajes de Nuestro Señor Jesucristo" },
  { path: "/mensaje-central", titulo: "Mensaje Central" },
  { path: "/consagraciones", titulo: "Consagraciones" },
  { path: "/santo-rosario", titulo: "Santo Rosario" },
  { path: "/pedidos-oracion", titulo: "Pedidos Oración" },
  { path: "/historia-aparicion", titulo: "Historias de las Apariciones" },
  { path: "/preguntas-frec", titulo: "Preguntas Frecuentes" },
  { path: "/devocionario", titulo: "Devocionario" },
];

export default function Menu() {
  let location = useLocation();
  const [titleNav, setTitleNav] = useState("");


  useEffect(() => {
    for (let i = 0; i < titulos.length; i++) {
      const element = titulos[i];
      if (element.path === location.pathname) {
        setTitleNav(element.titulo);
      }
    }
  }, [location]);

  return (
    <>
      <div className="barra-menu">
        <h3
          className="text-uppercase text-start"
          style={{ fontSize: "1.2rem" }}
        >
          {titleNav}
        </h3>
        {location.pathname === "/mensajes-virgen/es" && (
          <Dropdown className="drop-menu">
            <Dropdown.Toggle id="dropdown-basic">
              Mensajes del año
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="/mensajes-virgen/es#1990">
                1990 - 1994
              </Dropdown.Item>
              <Dropdown.Item href="/mensajes-virgen/es#1995">
                1995
              </Dropdown.Item>
              <Dropdown.Item href="/mensajes-virgen/es#1996">
                1996
              </Dropdown.Item>
              <Dropdown.Item href="/mensajes-virgen/es#1997">
                1997
              </Dropdown.Item>
              <Dropdown.Item href="/mensajes-virgen/es#2003">
                Posterior a 2003
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
        <button
          className="btn ms-auto"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasExample"
          aria-controls="offcanvasExample"
        >
          <i className="bi bi-list icon-menu"></i>
        </button>
      </div>

      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasMainMenu"
      >
        <div className="offcanvas-body">
          <ul>
            <Nav.Link to="/" as={NavLink} data-bs-dismiss="offcanvas">
              <li>Inicio</li>
            </Nav.Link>
            <hr />
            <div className="d-flex mt-1 mensajes-virgen-nav-link">
              <Nav.Link
                to="/mensajes-virgen/es"
                as={NavLink}
                data-bs-dismiss="offcanvas"
              >
                <li>Mensajes de la Santísima Virgen María</li>
              </Nav.Link>
              <div className="mb-2 offcanva-country-flags">
                {["end"].map((end) => (
                  <DropdownButton
                    className="mt-4"
                    key={end}
                    id={`dropdown-button-drop-${end}`}
                    drop={end}
                    variant="secondary"
                    title={``}
                  >
                    <Dropdown.Item eventKey="2">
                      <Nav.Link
                        className="dropdownMenuLinks"
                        to="/mensajes-virgen/es"
                        as={NavLink}
                        data-bs-dismiss="offcanvas"
                      >
                        <img
                          className="menuEmojis mt-2"
                          src="https://images.emojiterra.com/google/noto-emoji/v2.034/128px/1f1ea-1f1f8.png"
                          alt="lenguaje español"
                        />
                      </Nav.Link>
                      <hr />
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="1">
                      <Nav.Link
                        className="dropdownMenuLinks"
                        to="/mensajes-virgen/en"
                        as={NavLink}
                        data-bs-dismiss="offcanvas"
                      >
                        <img
                          className="menuEmojis mt-2"
                          src="https://images.emojiterra.com/google/noto-emoji/v2.034/128px/1f1ec-1f1e7.png"
                          alt="lenguaje ingles"
                        />
                      </Nav.Link>
                      <hr />
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="3">
                      <Nav.Link
                        className="dropdownMenuLinks"
                        to="/mensajes-virgen/fr"
                        as={NavLink}
                        data-bs-dismiss="offcanvas"
                      >
                        <img
                          className="menuEmojis"
                          src="https://images.emojiterra.com/google/noto-emoji/v2.034/128px/1f1eb-1f1f7.png"
                          alt="française langue"
                        />
                      </Nav.Link>
                      <hr />
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="4">
                      <Nav.Link
                        className="dropdownMenuLinks"
                        to="/mensajes-virgen/ger"
                        as={NavLink}
                        data-bs-dismiss="offcanvas"
                      >
                        <img
                          className="menuEmojis"
                          src="https://images.emojiterra.com/google/noto-emoji/v2.034/128px/1f1e9-1f1ea.png"
                          alt=""
                        />
                      </Nav.Link>
                    </Dropdown.Item>
                  </DropdownButton>
                ))}
              </div>
            </div>
            <hr />
            <Nav.Link
              to="/mensajes-jesus"
              as={NavLink}
              data-bs-dismiss="offcanvas"
            >
              <li>Mensajes de Nuestro Señor Jesucristo</li>
            </Nav.Link>
            <hr />
            <Nav.Link
              to="/mensaje-central"
              as={NavLink}
              data-bs-dismiss="offcanvas"
            >
              <li>Mensaje Central</li>
            </Nav.Link>
            <hr />
            <Nav.Link
              to="/consagraciones"
              as={NavLink}
              data-bs-dismiss="offcanvas"
            >
              <li>Consagraciones</li>
            </Nav.Link>
            <hr />
            <Nav.Link
              to="/santo-rosario"
              as={NavLink}
              data-bs-dismiss="offcanvas"
            >
              <li>Santo Rosario</li>
            </Nav.Link>
            <hr />
            <Nav.Link
              to="/devocionario"
              as={NavLink}
              data-bs-dismiss="offcanvas"
            >
              <li>Devocionario</li>
            </Nav.Link>
            <hr />
            <Nav.Link
              to="/historia-aparicion"
              as={NavLink}
              data-bs-dismiss="offcanvas"
            >
              <li>Historia de las apariciones</li>
            </Nav.Link>
            <hr />
            <Nav.Link
              href="mailto:pedidosdeoracion@inmaculadamadre-salta.org?subject=Pedido%20de%20oración"
              data-bs-dismiss="offcanvas"
            >
              <li>Realizar un pedido de oración</li>
            </Nav.Link>
            <hr />
            <Nav.Link
              to="/preguntas-frec"
              as={NavLink}
              data-bs-dismiss="offcanvas"
            >
              <li>Preguntas frecuentes</li>
            </Nav.Link>
            <hr />
          </ul>
        </div>
      </div>
    </>
  );
}
